import styled from "@emotion/styled/macro";
import { colors, shadows, views } from "../../../../common/styles/theme.styles";
import { keyframes } from "@emotion/react";



const progressBar = keyframes`
    0% { left:0; width: 0; }
    50% { left:0; width: 100% }
    100% { left:100%; width: 0 }
`;

export const UploadAnimatedBar = styled.div`
    background-color: ${colors.darkGray1};
    height: 2px;
    width: 100%;
    position: absolute;
    /* transition : width 5s ease; */
    animation: ${progressBar} 5s ease-in-out infinite;
`;

export const UploadAnimatedBarWrapper = styled.div`
    background-color: ${colors.gray3};
    height: 2px;
    position: relative;
    width: 100%;
`;

export const VaultDropAreaWrapper = styled.div`
    display: flex;
    padding-bottom: 45px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    position: relative;
`;

export const VaultDropAreaBody = styled.div`
    display: flex;

    ${({ isWelcome }) => isWelcome ? `
        height: 400px;
        padding: 5px 8px;
        background-color: #FFFFFF;
    ` : `
        height: 250px;
        padding: 48px 0;
        background-color: ${props => props.isHoverActive ? colors.lightGray1 : '#F1F3F5'};
        flex-direction: column;
    `}

    width: 100%;
    justify-content: center;
    align-items: center;

    border-radius: 8px;
    border: 1px dashed var(--Dark-Gray-1, #1A1B1D);

`;

export const VaultFileDropArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    height: 100%;
`;

export const VaultFileDropAreaDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

export const ImportPersonalBalanceWrapper = styled.div`
    display: inline-flex;
    height: 64px;
    padding: 12px 24px 14px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 39px;
    border: 1px solid ${colors.gray3};
    background: #FFF;
    box-shadow: ${shadows.cardShadow}
`;

export const UploadAnyWhiteWrapper = styled.div`
    display: inline-flex;
    height: 64px;
    width: 319px;
    padding: 12px 32px 14px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    border-radius: 39px;
    border: 1px solid ${colors.gray3};
    background: #FFF;
    box-shadow: ${shadows.cardShadow};
    cursor: pointer;
`;
export const IllustrationIconWrapper = styled.div`
    // padding-bottom:8px;
`;

export const IllustrationIconTextTopRow = styled.div`
    color: ${colors.darkGray1};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    ${views.tablet}{
        font-weight: 450;
        text-align:center;
    }
`;

export const IllustrationIconTextSecondRow = styled.div`
    color: ${colors.darkGray1};
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    ${views.tablet}{
        color:${colors.darkGray2};
        text-align: center;
    }
`;

export const VaultFileDropAreaInfoWrapper = styled.div`
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;

    position: absolute;
    top: 16px;
    right: 16px;
`;

export const VaultFileDropAreaInfoDataWrapper = styled.div`
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    opacity:0;
`;

export const VaultFileDropAreaInfoData = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 4px;
    align-items: center;

    top: 8px;

    border-radius: 8px;
    background-color: ${colors.darkGray1};
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    padding: 16px;
    box-shadow: ${shadows.popupShadow};
    transition: all 0.2s;
`;

export const VaultFileDropAreaInfo = styled.div`
    display: flex;
    height: 32px;
    padding: 0px 12px 0px 8px;
    align-items: center;
    gap: 8px;

    border-radius: 6px;
    border: 1px solid rgba(88, 93, 102, 0.50);
    background: #232628;

    box-shadow: ${shadows.toggleShadow};

    position: relative;

    :hover {
        ${VaultFileDropAreaInfoDataWrapper} {
            display: flex;
            z-index: 1;
            opacity:1;
        }
    }
`;

export const VaultFileDropAreaInfoContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
`;

export const VaultFileDropAreaInfoIcon = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 1.666px 0.833px 1.667px 2.5px;
    justify-content: center;
    align-items: center;
`;

export const VaultFileDropAreaInfoText = styled.div`
   color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;

export const VaultConciergeContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 250px;
`

export const VaultConciergeContent = styled.div`
    cursor: pointer;
    color: #72E1AC;
    white-space: nowrap;
    font-weight: 600;
    display: flex;
    align-items: center;
    span {
        margin-left: 4px;
        padding-top: 4px;
    }
`;


